/**
 * Side-effect module: registers the dashboard reducer with the store.
 *
 * Imported at the top of every page that renders the sidebar, so the slice is
 * injected with whichever chunk loads first. injectReducer is idempotent.
 */
import { injectReducer } from '@app/store';

import reducer from './slice';

injectReducer('dashboard', reducer);
